import React, {useEffect, useState, useRef} from 'react';
import Axios from 'axios';
import { Alert } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import '../App.css';
import Pagination from '../components/global/Paginator'
import {exportToExcel} from "../utils/reports/exportToExcel";
import {formatDate} from "../utils/dates";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExcel} from "@fortawesome/free-solid-svg-icons";

function Grillaboticketsaldosnegativosreport (props){
    const fileInputRef = useRef();
    const searchInput = useRef(null);
    const [show, setShow] = useState(false);
    const [datos, setDatos] = useState([]);
    const [datosDetalle, setDatosDetalle] = useState([]);
    const [datosBackup, setDatosBackup] = useState([])
    const [datosExport, setDatosExport] = useState([]);
    const [idcasino, setIdCasino] = useState()

    const [direccioncasino, setDireccionCasino] = useState()
    const [valorticketcasino, setValorTicketCasino] = useState()
    const [fecha, setFecha] = useState('')
    const [visible, setVisible] = useState('seccionNoVisible')
    const [beneficiariobyuser, setBeneficiariobyuser] = useState([])
    const [beneficiario, setBeneficiario] = useState()
    const [ticketid, setTicketId] = useState()
    const [user, setUser] = useState()
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);


    const [fechaInicio, setFechaInicio] = useState('')
    const [usuario, setUsuario] = useState('')
    const [fechafinal, setFechaFinal] = useState('')
    const [file, setFile] = useState('');
    const [fileName, setFileName] = useState("");
    const [barcoderest, setBarcoderest] = useState('')
    const [pageNumber, setPageNumber] = useState('')
    const [pageSize, setPageSize] = useState(3);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);   

    // Referencia para el número de página (evitar estados desincronizados)
    const pageRef = useRef(currentPage);
 

    let statuscall = '' 
    
    const dataList = datos.map((item, i) =>
        <tr key={i} class="divide-y divide-gray-100 bg-white">
            <td class="px-6 py-4 whitespace-nowrap text-sm">{item.user_id}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">{item.suma_valor}</td>
            <td class="px-6 py-4 whitespace-nowrap text-right text-sm">
                <button class="text-indigo-600 hover:underline text-sm" onClick={() => verDetalleSaldo(item.user_id)}>Detalle Saldo</button>
            </td>
        </tr>
    );


    const handleExport = () => {
    
        let idcasino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        Axios.get(process.env.REACT_APP_URLTICKETSALDOSNEGATIVOSREPORTEXCEL, {
            params: {
                casino: idcasino.replace('"', ''),
                usuario: usuario || ''                
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatosExport(response.data.saldonegativo)
        }).catch(error => {
            return error     
        });

        const formattedData = datosExport.map((saldonegativo) => ({
            Usuario: saldonegativo.user_id,
            Saldo: saldonegativo.suma_valor
        }))
        exportToExcel(formattedData, `ReporteSaldosnegativos_${formatDate()}.xlsx`, "Saldos");
    };

    const dataListDetalle = datosDetalle.map((item, i) => 
        <div key={i} className="bg-gray-200 p-6 rounded-lg shadow-md mt-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Detalle Consumos</h3>
        
        {/* Contenedor con grid de 4 columnas, en pantallas grandes */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        
        {/* Columna 1 */}
        <div className="space-y-2">
            {/* Número de Índice - destacado */}
            <div className="flex justify-end">
            <span className="bg-indigo-600 text-white px-3 py-1 rounded-lg text-xl font-bold">{i + 1}</span>
            </div>

            {/* RUT Cliente */}
            <div className="flex justify-end">
            <span className="font-medium text-gray-500">Usuario:</span>
            <span className="font-semibold text-gray-800">{item.usuario}</span>
            </div>
        </div>

        {/* Columna 2 */}
        <div className="space-y-2">
            {/* Nombre Cliente */}
            <div className="flex justify-end">
            <span className="font-medium text-gray-500">Alumno:</span>
            <span className="font-semibold text-gray-800">{item.alumno}</span>
            </div>

            {/* RUT Beneficiario */}
            <div className="flex justify-end">
            <span className="font-medium text-gray-500">Fecha consumo:</span>
            <span className="font-semibold text-gray-800">{item.fecha_consumo}</span>
            </div>
        </div>

        {/* Columna 3 */}
        <div className="space-y-2">
            {/* Valor Ticket */}
            <div className="flex justify-end">
            <span className="font-medium text-gray-500">Estado consumo:</span>
            <span className="font-semibold text-gray-800">{item.estado_consumo}</span>
            </div>

            {/* Estado Pago */}
            <div className="flex justify-end">
            <span className="font-medium text-gray-500">Estado pago:</span>
            <span className="font-semibold text-green-800">{item.estado_pago}</span>
            </div>
        </div>

        {/* Columna 4 */}
        <div className="space-y-2">
            {/* Estado Consumo */}
            <div className="flex justify-end">
            <span className="font-medium text-gray-500">Valor:</span>
            <span className="font-semibold text-green-800">$ -{item.valor}</span>
            </div>
        </div>
        </div>
    </div>);

    const handlePageSize = (e) => {
        setPageSize(e.target.value)
    }

    const GetTicket = () =>
    {
        const date = new Date();

        // Formateamos la fecha en formato yyyy-mm-dd
        const formattedDate = date.toISOString().split('T')[0];
        let idcasino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        Axios.get(process.env.REACT_APP_URLTICKETSALDOSNEGATIVOSREPORT, {
            params: {
                page: pageNumber || 1,
                pageSize: pageSize || 10,
                casino: idcasino.replace('"', ''),
                usuario: usuario || ''
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            
            setDatos(response.data.saldonegativo)
            setDatosBackup(response.data.saldonegativo)

            setCurrentPage(response.data.saldonegativo_metadata.currentPage)
            setPageNumber(response.data.saldonegativo_metadata.currentPage)

            setTotalPages(response.data.saldonegativo_metadata.totalPages)
        }).catch(error => {
            return error     
        });
    }

    useEffect(() => {
        GetTicket()

    }, [pageNumber]);



    const verDetalleSaldo= (user_id) =>{
        //Busca beneficiarios por usuario
        Axios.get(process.env.REACT_APP_URLTICKETSALDOSNEGATIVOSREPORTDETALLE, {
            params: {
                usuario: user_id 
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatosDetalle(response.data.detalle_saldonegativo)
            //Setea beneficiario
            //setSelectBeneficiarios(listBeneficiarios)
        }).catch(error => {
            return error     
        });

        handleShow()
    }

    const handleClose = () => {
        setBeneficiario('')
        setFecha('')
        setShow(false)
    }
    const handleShow = () => setShow(true)

    const handleChangeList= (e) => {
        let text = e.target.value;
        const setBusqueda = e.target.value;
        const data = datosBackup
        const newData = data.filter(
            function(item){
                const itemDataUsuario = item.user_id
                const campo = itemDataUsuario
                const textData = text
                return campo.indexOf(textData) > -1        
            }
        )
        setDatos(newData)
    }

    const handleFechaInicio = (e) => {
        setFechaInicio(e.target.value)
    }

    const handleUsuario = (e) => {
        setUsuario(e.target.value)
    }

    const handleFechaFinal = (e) => {
        setFechaFinal(e.target.value)
    }

    return(
    <div className='w-full'>
        {/* Zona 1 - Filtros */}
        <div className="bg-white shadow-lg p-6 mx-4 mb-2">


        {/* Zona 1 - Header con Título y Filtros */}
        <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
        <h1 class="text-2xl font-bold">Saldos Negativos</h1>

        <div class="flex flex-wrap gap-4">
            {/* Filtro de pagina */}
            <div className="flex flex-col">
                    <input 
                    type="number" 
                    id="numeroPaginas"
                    placeholder='Registros por pagina'
                    value={pageSize}
                    onChange={handlePageSize} 
                    min="1" 
                    step="1" 
                    defaultValue="1" 
                    class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
            </div>

            {/*Usuario*/}
            <div class="relative">
            <input type="text" 
                placeholder="Usuario" 
                class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                id="usuario"
                value={usuario}
                onChange={handleUsuario}
                min="1" 
                step="1" 
                defaultValue="1" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35m1.4-5.4a7 7 0 11-14 0 7 7 0 0114 0z"/>
                </svg>
            </div>
            </div>

            {/*Buscador*/}
            <div class="relative">
            <input type="text" 
                placeholder="Search..." 
                class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                id="Buscar en grilla"
                onChange={handleChangeList} />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35m1.4-5.4a7 7 0 11-14 0 7 7 0 0114 0z"/>
                </svg>
            </div>
            </div>

            {/* Botón generar reporte */}
            <button
                onClick={GetTicket}
                className="flex items-center gap-2 bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium px-4 py-2 rounded-lg shadow"
                >
                <svg
                    className="w-4 h-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 4H7a2 2 0 01-2-2V6a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2z"
                    />
                </svg>
                <span>Generar Reporte</span>
            </button>

            {/*Botón Exportar a Excel*/}
            <button onClick={handleExport} class="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium px-4 py-2 rounded-lg shadow">
            <svg class="w-4 h-4 fill-current text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path d="M384 121.9V128H272V0H128C92.7 0 64 28.7 64 64v384c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160h64v-38.1c0-13.1-10.6-23.9-23.7-23.9H384zM299.1 272l-42.1 48 42.1 48H258l-26.5-31.1L205 368h-40.5l42.1-48-42.1-48H205l26.5 31.1L258 272h41.1z"/>
            </svg>
            <span>Export</span>
            <svg class="w-4 h-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4" />
            </svg>
            </button>
        </div>
        </div>
        
        
        </div>

        {/* Zona 2 */}
        <div className="bg-white shadow-lg p-4 mx-4 mb-2">
            {/* Controles de Búsqueda y Exportar */}
            <div className="overflow-y-auto h-[600px] p-4">
                {/* Contenedor para los detalles de los tickets */}
                <div className="space-y-6">
                    <div class="bg-white shadow rounded-2xl overflow-hidden">
                        <div class="max-h-96 overflow-y-auto">
                            <table class="min-w-full table-auto">
                            <thead class="bg-gray-50 sticky top-0 z-10">
                                <tr>
                                    <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Email</th>
                                    <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Saldo</th>
                                    <th class="px-6 py-4 text-right text-sm font-semibold text-gray-600 bg-gray-50">Acciones</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-100 bg-white">
                                {dataList}
                            </tbody>
                            </table>
                        </div>

                        {/*Paginación*/} 
                        <div class="flex items-center justify-between mt-6">
                            <div class="inline-flex items-center space-x-2">
                            <Pagination currentPage={pageNumber} totalPages={totalPages} onPageChange={setPageNumber}/>            
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
            

        <Modal show={show} onHide={handleClose} size="xl" fullscreen="true">
            <Modal.Header closeButton>
                <Modal.Title>Detalle saldo negativo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alert
                        ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlert}</Alert.Heading>
                                <p>
                                    {textoAlert}
                                </p>
                        </Alert>
                        :''
                        }
                    </div>
                </div>
                <div className="overflow-y-auto h-[600px] p-4">
                    {/* Contenedor para los detalles de los tickets */}
                    <div className="space-y-6">
                        {dataListDetalle}
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <button onClick={handleClose}>
                    Cerrar
                </button>
            </Modal.Footer>
            <Modal.Footer className={visible}>
            <div>
                <h4>Debe completar todos los campos</h4>
            </div>
            </Modal.Footer>
        </Modal>                                                                                                                                                                                           
    </div>    
    )
}
export default Grillaboticketsaldosnegativosreport